import Bouncer from 'formbouncerjs';
import { message } from './constant';

export default new class Validation {
  constructor() {
    this.formForValidationSelector = '._required';
    this.inValidSelector = '_invalid';

    this.handler();
  }

  handler() {
    document.addEventListener('DOMContentLoaded', () => {
      this.validate(this.formForValidationSelector);
    });
  }

  validate(selector) {
    this.validation = new Bouncer(selector, {
      fieldClass: 'validation-error',
      errorClass: 'validation-error__message',
      fieldPrefix: 'validation-error-',
      errorPrefix: 'validation-error-',
      messageAfterField: true,
      messageCustom: 'data-bouncer-message',
      messageTarget: 'data-bouncer-target',
      disableSubmit: true,
      customValidations: {
        valueMismatch(field) {
          // Look for a selector for a field to compare
          // If there isn't one, return false (no error)
          const passwordSelector = field.getAttribute('data-bouncer-match');
          if (!passwordSelector) return false;

          // Get the field to compare
          const otherField = field.form.querySelector(passwordSelector);
          if (!otherField) return false;

          // Compare the two field values
          // We use a negative comparison here because if they do match, the field validates
          // We want to return true for failures, which can be confusing
          // this.messageCustom = this.messageCustom;
          return otherField.value !== field.value;
        },
      },
      /* eslint no-unused-vars: "off" */
      messages: {
        valueMismatch(field) {
          const customMessage = field.getAttribute('data-bouncer-message');
          return customMessage || 'Please make sure the fields match.';
        },
      },

    });

    document.addEventListener('bouncerFormValid', ({ target }) => {
      target.classList.remove(this.inValidSelector);
    });

    document.addEventListener('bouncerFormInvalid', ({ target }) => {
      target.classList.add(this.inValidSelector);
    });
  }
}();
